// Lottie
import lottie from "lottie-web"; 

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

document.querySelectorAll("[data-lottiejspath]").forEach(function(file) {
	lottie.loadAnimation({
		  container: file, // the dom element that will contain the animation
		  renderer: 'svg',
		  name : file.id,
		  loop: file.dataset.loop == "1" ? true : false,
		  autoplay: false,
		  path:  file.dataset.lottiejspath // the path to the animation json
	 }); 

	 document.querySelectorAll("[data-autoplay='1']").forEach(function(file) {
        if(isInViewport(document.getElementById(file.id))) {
            lottie.play(file.id);					 
        }
    });
});

window.addEventListener('scroll', function() {
	document.querySelectorAll("[data-autoplay='1']").forEach(function(file) {
        if(isInViewport(document.getElementById(file.id))) {
            lottie.play(file.id);					 
        }
    });
});




// Lottie END